import { ContainerComponent, wrap } from 'AppReact';
import { TableHeaderRow, Th, THead, Pr3, Pr1 } from 'wrappers';
import { TableHeaderElement } from 'molecules';
import Controller from './controller';
import internalState from './internalState';

export const definition = {
  name: 'Header',
  controller: Controller,
  initialProps: ({ orderBy, orderDirection, content }) => ({ orderBy, orderDirection, content }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(TableHeaderRow, THead),
      name: 'Header',
      elements: [
        {
          component: wrap(wrap(TableHeaderElement, Pr3), Th),
          isListOf: 'content',
          name: 'Cell',
          bindings: ({ orderBy, orderDirection, content }) => ({ orderDirection, orderBy, content, sortOrder: orderBy === content.sortingField ? orderDirection : '' }),
          displayState: ({ content }) => ({ increasePadding: content.increasePadding })
        }
      ]
    }
  ]
};

const Header = ContainerComponent(definition);
export default Header;
